module.exports = __webpack_public_path__ + "static/media/raised_hand.d87afac2.svg";